<template>
  <div class="page-counter">
    <div class="page-counter-bg">
      <div class="language-page-title">
        <div class="language-change-main">
          <div
            class="language"
            :class="{ active: language == 'CN' }"
            @click="handleChangeLanguage('CN')"
          >
            中文
          </div>
          <span>|</span>
          <div
            class="language"
            :class="{ active: language == 'EN' }"
            @click="handleChangeLanguage('EN')"
          >
            EN
          </div>
        </div>
        <!-- <div>湛江巴斯夫智慧食堂</div> -->
      </div>
      <div class="page-cardInfo-balance">
        <div class="card-name">{{ userInfo.shopName }}</div>
        <div class="customer-info-balance">
          <div class="customer-name">{{ language == 'CN' ? userInfo.customerName : userInfo.customerNameEn || userInfo.customerName }}</div>
          <div class="prohibit-preview" v-if="previewFlag">******</div>
          <div class="page-show-price" v-else>
            {{ (userInfo.balance / 100).toFixed(2) }}
          </div>
          <van-icon
            name="closed-eye"
            size="16"
            v-if="!previewFlag"
            @click="handleChangePreview(true)"
          />
          <van-icon
            name="eye-o"
            size="16"
            v-else
            @click="handleChangePreview(false)"
          />
        </div>
      </div>
    </div>

    <!-- <div class="apply-text">一卡通应用</div> -->
    <div class="page-banner-menu-counter">
      <!-- 轮播 -->
      <div class="page-banner-main">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="item in bannerList" :key="item.id">
            <img :src="item.mainPicUrls" alt="" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="menu-counter">
        <div class="menu-counter-main">
          <div
            class="menu-items"
            @click="$handleExec(item)"
            v-for="(item, index) in menus"
            :key="index"
          >
            <img :src="item.icon" alt="" />
            <span>{{ language == 'CN' ? item.name : item.nameEn }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-logo-counter">
      <img src="@/assets/imgs/product_logo.png" class="bottom-logo" alt="">
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  data() {
    return {
      customerId: "",
      userInfo: {},
      showQueit: "",
      shopId: "",
      loginType: localStorage.getItem("loginType"),
      admissionStatus: false,
      menus: [],
      language: localStorage.getItem("language") || "CN",
      previewFlag: true,
      bannerList: [],
    };
  },
  created() {
    // if (!sessionStorage.getItem("token")) {
    //   let url = localStorage.getItem("homeUrl");
    //   window.location.href = url || location.origin;
    // }
    // /customer/branch/list
  },
  async mounted() {
    this.getCustomerH5Menu();
    this.shopId = localStorage.getItem("shopId");
    this.showQueit = localStorage.getItem("showQuit") || "";
    let roles = JSON.parse(localStorage.getItem("customerInfoList"));
    this.customerId =
      (roles && roles[0].customerId) || localStorage.getItem("customerId");
    const locationId = localStorage.getItem("locationId");
    this.getShopBannerList();
    await this.getBalance();
  },
  methods: {
    // 获取首页banner图片列表
    async getShopBannerList() {
      const { data: res } = await this.$authAjax.get(
        "/api/shopBannerInfo/listForH5",
        {
          params: {
            shopId: this.shopId,
            linkType: 1,
          },
        }
      );
      console.log(res, "===res branner");
      this.bannerList = res?.data?.list;
    },
    async getCustomerH5Menu(store) {
      const res = await this.$authAjax.get("/api/wxapp/h5Menu/customer/list");
      const data = res.data.data;
      sessionStorage.setItem("customerH5MenuConfigs", JSON.stringify(data));
      // store.commit("SET_MENU_CONFIGS", data);
      // await store.dispatch("getCustomerOftenH5Menu");
      // this.menus =
      console.log("data=====>", data);
      this.menus = data
        .filter((item) => ["route", "function"].includes(item?.styleJson?.type))
        .map((item) => {
          return {
            ...item,
            icon: item?.styleJson?.menuIconValue || "",
            path: item?.styleJson?.path || "",
            name: item?.styleJson?.menuName,
            nameEn: item?.styleJson?.menuNameEn,
            id: item.id,
            handle: item?.styleJson?.path,
            iconKey: item?.styleJson?.menuIcon,
            title: item?.styleJson?.menuName,
            type: item?.styleJson?.menuType,
          };
        });
        console.log(this.menus,'menus');
        
    },
    async getBalance() {
      let data = {
        shopId: this.shopId,
        customerId: this.customerId,
      };
      const { data: resData } = await this.$logina.post(
        "/api/wxapp/customer/getBalanceV3",
        data
      );
      if (resData.code == 200) {
        this.userInfo = resData.data;
        localStorage.setItem("customerName", resData.data.customerName);
        localStorage.setItem("userPhone", resData.data.phone);
        localStorage.setItem("cardNo", resData.data.cardNo);
        localStorage.setItem("costCenterNo", resData.data.costCenterNo);
      } else {
        this.$toast(resData.message);
      }
    },

    handleChangePreview(flag) {
      this.previewFlag = flag;
    },
    // 切换语言
    handleChangeLanguage(language) {
      this.language = language;
      localStorage.setItem("language", this.language);
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.page-counter {
  min-height: calc(100vh - 40px);
  background: #f4f4f4;
  position: relative;
  overflow: auto;
  &-bg {
    height: 148px;
    background: url("../../assets/image/bg2@2x.png") no-repeat;
    background-size: 100% 100%;
    padding: 12px;
    box-sizing: border-box;
    .language-page-title {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .language-change-main {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 14px;
        span {
          color: #fff;
        }
        .language {
          &.active {
            color: #fff;
          }
        }
      }
    }
    .page-cardInfo-balance {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 40px;
      .card-name {
        font-size: 14px;
        color: #fff;
      }
      .customer-info-balance {
        display: flex;
        align-items: center;
        gap: 4px;
        .customer-name {
          font-size: 14px;
          color: #fff;
        }
        .prohibit-preview {
          font-size: 13px;
        }
        .page-show-price {
          font-size: 14px;
        }
      }
    }
  }
  &-card-main {
    // width: 346px;
    height: 281px;
    background-image: url("../../assets/image/card6@2x.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: -128px auto 0 auto;
    padding: 18px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    img {
      width: 102px;
      height: 36px;
    }
    .card-userinfo {
      display: flex;
      flex-direction: column;
      gap: 7px;
      margin-top: 218px;
      margin-left: 16px;
      .name {
        font-size: 18px;
        font-weight: 300;
        color: #ffffff;
      }
      .balance-money {
        font-size: 15px;
      }
    }
  }

  .my-blance {
    margin-top: 18px;
    background: #f8fcff;
    // border-radius: 10px;
    padding: 19px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .blance-title {
      font-size: 16px;
      font-weight: 400;
      color: #000000;
    }
    .my-blance-money {
      font-size: 14px;
      font-weight: 500;
      color: #2086dd;
      .money-unit {
        font-size: 12px;
      }
    }
  }

  .apply-text {
    padding: 24px 0 21px 18px;
    font-size: 16px;
    font-weight: 300;
    color: #000000;
  }

  .page-banner-menu-counter {
    margin-top: -50px;
    border-radius: 12px 12px 0 0;
    background: #fff;
    padding: 12px;
    box-sizing: border-box;
    .page-banner-main {
      height: 140px;
      img {
        width: 100%;
        height: 140px;
      }
    }
  }
  .menu-counter {
    // border-radius: 10px;
    // background: #fff;
    // min-height: 24vh;
    padding: 5px 0 70px 0;
    box-sizing: border-box;

    &-main {
      display: flex;
      flex-wrap: wrap;

      .menu-items {
        width: calc(33%);
        box-sizing: border-box;
        padding: 12px 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 14px;
        // border-right: 1px solid rgb(0, 0, 0, 0.1);
        // border-bottom: 1px solid rgb(0, 0, 0, 0.1);
        img {
          width: 24px;
          height: 28px;
          object-fit: contain;
        }

        span {
          font-size: 13px;
          font-weight: 400;
          text-align: center;
        }
      }
    }
  }
  .bottom-phone {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    text-align: center;
    height: 60px;
    position: fixed;
    line-height: 26px;
    background: #f4f4f4;
    bottom: env(safe-area-inset-bottom);
    left: 0;
    span {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      &:last-child {
        color: #21c2f1;
      }
    }
  }
}
.bottom-logo-counter {
  padding: 12px 0;
  background: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  .bottom-logo {
    width: 180px;
    height: 70px;
    object-fit: cover;
  }
}
</style>
